import { FC, useState } from 'react'
import {
	Alert,
	Button,
	Container,
	FormField,
	Header,
	SpaceBetween,
	Textarea
} from '@cloudscape-design/components'
import type { MongoDBRequest } from '../../../types/mongodb'
import useRejectMongoDB from '../../../hooks/mutate/useRejectMongoDB'
import { getMongoDBErrorMessage } from '../RequestError'

interface RejectionFormProps {
	request: MongoDBRequest
	onClose: () => void
	onSubmitted: () => void
}

const RejectionForm: FC<RejectionFormProps> = ({
	request,
	onClose,
	onSubmitted
}) => {
	const [comment, setComment] = useState('')
	const [commentError, setCommentError] = useState('')
	const {
		mutate: rejectMongoDB,
		isLoading,
		isError,
		error
	} = useRejectMongoDB(request.mongoDBID)
	const eligible =
		request.status === 'PENDING_APPROVAL' && !request.correctionPending

	const handleReject = () => {
		if (!eligible || isLoading) return
		if (!comment.trim()) {
			setCommentError('Enter a reason for rejection.')
			return
		}
		rejectMongoDB(
			{
				action: 'REJECT',
				mongoDBID: request.mongoDBID,
				comment: comment.trim()
			},
			{
				onSuccess: () => {
					setComment('')
					onSubmitted()
				}
			}
		)
	}

	return (
		<Container header={<Header variant="h2">Reject MongoDB Request</Header>}>
			<SpaceBetween direction="vertical" size="m">
				<FormField
					label="Reason for rejection"
					errorText={commentError || undefined}
				>
					<Textarea
						value={comment}
						disabled={isLoading}
						onChange={({ detail }) => {
							setComment(detail.value)
							setCommentError('')
						}}
					/>
				</FormField>
				{isError && <Alert type="error">{getMongoDBErrorMessage(error)}</Alert>}
				<SpaceBetween direction="horizontal" size="xs">
					<Button disabled={isLoading} onClick={onClose}>
						Cancel
					</Button>
					<Button
						variant="primary"
						loading={isLoading}
						disabled={!eligible || isLoading}
						onClick={handleReject}
					>
						Reject
					</Button>
				</SpaceBetween>
			</SpaceBetween>
		</Container>
	)
}

export default RejectionForm
